import { Wrapper } from "../components/wrapper";

export default function Sobre(): JSX.Element {
  return (
    <Wrapper className="pt-6 md:pt-20 md:pb-52 pb-12 flex flex-col gap-6">
      <h1 className="text-2xl font-semibold text-primary-900">Termos de Uso</h1>
      <div className="flex flex-col gap-6 md:flex-row md:justify-stretch">
        <div className="flex-1 text-sm font-normal text-neutral-900 px-6 py-6 flex flex-col gap-4 bg-primary-50 rounded-3xl">
          <h2 className="text-xl font-medium text-primary-700">
            Termos de Uso
          </h2>
          <p>
            <p>
              <span className="font-semibold">1. Aceitação dos Termos</span> Ao
              acessar e utilizar o HelpSaude, você aceita e concorda em estar
              vinculado pelos termos e provisões deste acordo. Além disso, ao
              utilizar estes serviços, você estará sujeito a quaisquer regras ou
              diretrizes aplicáveis que tenham sido publicadas. Todas as
              participações nos serviços do HelpSaude são consideradas como uso
              dos mesmos e são regidas por este acordo.
            </p>
            <p>
              <span className="font-semibold">2. Descrição do Serviço</span> O
              HelpSaude fornece uma plataforma online que conecta pacientes com
              prestadores de saúde, permitindo que pacientes encontrem
              prestadores de saúde com base em localização, especialidade e
              seguro saúde. Não é necessário registro para pacientes, e o
              serviço é totalmente gratuito para uso dos mesmos.
            </p>
            <p>
              <span className="font-semibold">3. Propriedade Intelectual</span>{" "}
              Todo o conteúdo fornecido pelo HelpSaude é protegido por direitos
              autorais, marcas registradas, patentes ou outros direitos e leis
              de propriedade. Os usuários concordam em usar o conteúdo apenas de
              maneira permitida pelo serviço.
            </p>
            <p>
              <span className="font-semibold">4. Uso do Serviço</span> Os
              usuários concordam em usar o serviço apenas para fins permitidos e
              não se envolver em atividades que interfiram ou interrompam o
              serviço. O uso não autorizado ou a reprodução de qualquer
              informação fornecida é estritamente proibido.
            </p>
            <p>
              <span className="font-semibold">
                5. Isenções de Responsabilidade
              </span>{" "}
              O HelpSaude não oferece garantias quanto à precisão ou
              confiabilidade das informações fornecidas pelos prestadores de
              saúde. A responsabilidade pelas decisões tomadas com base nessas
              informações é exclusivamente dos usuários.
            </p>
            <p>
              <span className="font-semibold">
                6. Limitação de Responsabilidade
              </span>{" "}
              O HelpSaude não será responsável por quaisquer danos diretos,
              indiretos, incidentais, consequentes ou exemplares que possam ser
              sofridos pelos usuários devido ao uso do serviço.
            </p>
            <p>
              <span className="font-semibold">7. Modificações no Serviço</span>{" "}
              O HelpSaude reserva-se o direito de modificar ou descontinuar
              temporariamente ou permanentemente o serviço com ou sem aviso
              prévio.
            </p>
            <p>
              <span className="font-semibold">8. Contato</span> Para quaisquer
              questões ou dúvidas sobre os Termos de Uso, os usuários podem
              entrar em contato pelo email contato@helpsaude.com.
            </p>
          </p>
        </div>
      </div>
    </Wrapper>
  );
}
